




























































import { Component, Vue, Prop } from "vue-property-decorator";
import UnPaidOrderModal from "defi/components/partial/UnPaidOrderModal.vue";
import SchemeRaisingProcess from "defi/components/partial/SchemeRaisingProcess.vue";
import utils from "defi/utils";
import { ERROR } from "defi/constants";
import { Asset } from "@foxone/api/src/models/defi";

@Component({
  components: {
    UnPaidOrderModal,
    SchemeRaisingProcess
  }
})
class Deposit extends Vue {
  @Prop({ type: String, default: "" }) schemeId!: string;

  @Prop({ type: Object, default: () => ({}) }) limits!: Map<
    string,
    { min: number; max: number }
  >;

  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  @Prop({ type: Boolean, default: false }) isFull!: boolean;

  @Prop({ type: Array, default: () => [] }) assets!: Asset[];

  asset: any = null;

  loading = false;

  amount = "";

  form: any = null;

  unPaidOrderModalVisible = false;

  get rules() {
    const { min, max } = this.meta;
    return [
      v => Number(v) >= Number(min) || this.$t("common.amount.min", { min }),
      v => Number(v) <= Number(max) || this.$t("common.amount.max", { max })
    ];
  }

  get errorMessage() {
    const input = this.form?.inputs[0];
    return input?.errorBucket[0];
  }

  get meta() {
    const getAsset = this.$store.getters["wallet/mixin/getAssetById"];
    const formatNumber = this.$common.utils.number.format;
    const { limits, asset, isFull } = this;
    const { min = 0, max = 0 } = limits[this.asset?.id ?? ""] ?? {};
    const symbol = asset?.symbol.toUpperCase();
    const assets = this.assets.map(x => ({
      id: x.id,
      symbol: x.symbol,
      name: x.name,
      logo: x.icon
    }));
    const walletAsset = getAsset(this.asset?.id);
    const balance = walletAsset?.balance ?? "0";
    const submitDisabled = this.errorMessage || !this.amount;

    return {
      min,
      max,
      symbol,
      assets,
      balance,
      submitDisabled,
      minText: formatNumber({ n: min }),
      maxText: formatNumber({ n: max }),
      selectable: assets.length > 1,
      joinText: isFull ? this.$t("defi.node-full") : this.$t("common.join")
    };
  }

  mounted() {
    this.form = this.$refs.form as any;
    if (this.meta.assets.length > 0) {
      this.asset = this.meta.assets[0];
    }
  }

  handleFillAomount(value) {
    this.amount = value;
  }

  handleBuy() {
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (valid) {
      this.requestPutOrder();
    }
  }

  handleBlur() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  async requestPutOrder() {
    if (!this.schemeId) return;

    const data: any = {
      scheme_id: this.schemeId,
      quantity: +this.amount
    };

    if (this.meta.selectable) {
      data.asset_id = this.asset.id;
    }

    this.loading = true;
    try {
      const order = await this.$api.defi.putOrder(data);
      utils.payment.requestPayOrder(this, order.id, () => {
        this.$store.dispatch("defi/user/profile/loadWealths");
        this.$helper.toFusionPath(this, "defi", {
          name: "orders-id",
          params: { id: order.id }
        });
        this.$emit("reload");
      });
    } catch (error) {
      if (error.code === ERROR.HAS_UNPAID_ORDER) {
        this.unPaidOrderModalVisible = true;
        this.loading = false;
        return;
      }
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default Deposit;
